import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent,
  EmployeeWithProfile,
  ImportButton,
  DownloadButton,
} from "@comps/components";
import { handleDownloadFile, makeRequest, makeRequestStateless } from "@utils/helpers";
import { Commons, Const, colors } from "../../constants";
import { Badge, message } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests";
import { useSelector } from "react-redux";
import CreateLeaveRequest from "./components/CreateLeaveRequest";
import moment from "moment";
import ViewFlow from '@mods/common/ViewFlow';
//import ViewLeaveRequest from "./components/ViewLeaveRequest";
import ViewLeaveRequestHistory from "../../common/ViewLeaveRequestHistory";
import ViewLeaveRequest from "../myLeaves/components/ViewLeaveRequest";
import { getRequestFilters, getSubordinateScopeFilters } from "@mods/common/commonFilterFields";
import { useLocation } from "react-router-dom";
import CompanyRequestFlowButton from "@mods/common/CompanyRequestFlowButton";
import { downloadSampleReq } from "../../../common/requests";
import ImportSample from "../../../common/ImportSample";
const langKey = Const["leaveRequest"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["leaveRequest"].route
      }
    ]
  }
}

const IndexCompanyLeaveRequests = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState('');
  const [leaveTypeBalance, setLeaveTypeBalance] = useState([]);
  //start pagination states

  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'code',
      title: trans(Commons.code),
      dataIndex: "code",
    },
    {
      key: 'employment_id',
      title: trans(`${langKey}.employment_id`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.requestor } />
      },
    },
    {
      key: 'department_id',
      title: trans(`${langKey}.department_id`),
      render: (record) => {
        return record.requestor.department_name;
      }
    },
    {
      key: 'leave_type_id',
      title: trans(`${langKey}.leave_type_id`),
      dataIndex: "leave_type_name",
    },
    {
      key: 'next_requestee',
      title: trans(`${langKey}.next_requestee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.next_requestee_name } />
      },
    },
    {
      key: 'count',
      title: trans(`${langKey}.count`),
      dataIndex: "count",
    },
    {
      key: 'date',
      title: trans(`${langKey}.date`),
      render: (record) => {
        return moment(record.start).format('YYYY-MM-DD') + '-to-' + moment(record.end).format('YYYY-MM-DD')
      }
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },

    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onViewHistory={ record.status !== 'Pending' ? onViewHistory : '' }
          onViewFlow={ record.flow.length !== 0 ? onViewFlow : '' }
          onEdit={ record.status === 'Pending' ? onEdit : '' }
          onView={ onView }
          onDelete={ record.status === 'Pending' ? onDelete : '' }
          onCancelRequest={ (record.status !== 'Pending') ? (record.status !== 'Cancelled') ? onCancelRequest : '' : '' }
        >

        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================
  const location = useLocation();
  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [location.pathname, filters, currentPage]);

  const getAllData = () => {
    let payload = {
      page: currentPage,
      filters: `${props.filters};${filters}`,
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };

  const onSuccess = (response) => {
    if (props.module === "myLeaveRequest") {
      setLeaveTypeBalance(response.leave_types);
    }
    if (props.employmentId) {
      setLeaveTypeBalance(response.leave_types);
    }
    setPagination(response.leave_requests);
    setDataSource(response.leave_requests.data);
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    setChildComponent(
      <ViewLeaveRequest onCompleted={ onCompleted } record={ record } disabled={ false } action='edit' filters={ props.filters } module={ props.module } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <ViewLeaveRequest onCompleted={ onCompleted } record={ record } disabled={ true } action='view' filters={ props.filters } module={ props.module } />
    );
  };
  const onCancelRequest = (record) => {
    setChildComponent(
      <ViewLeaveRequest onCompleted={ onCompleted } record={ record } disabled={ false } action='cancel' filters={ props.filters } module={ props.module } />
    );
  };
  const onViewHistory = (record) => {
    setChildComponent(
      <ViewLeaveRequestHistory onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };
  const onViewFlow = (record) => {
    setChildComponent(
      <ViewFlow onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };
  const onDelete = (record) => {
    const payload = {
      filters: '', id: record.id
    }
    makeRequest(setLoader, deleteDataReq, payload, onDeleted, onError);
  };
  const onDeleted = (res) => {
    //onSuccess(res)
    getAllData();
    // setDataSource(res.leave_requests.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateLeaveRequest onCompleted={ onCompleted } authUser={ authUser } leavesOf='company' onSuccess={ onSuccess } filters={ props.filters } module={ props.module } employment_id={ props.employment_id } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ getFilterFields(props.module) } modkey={ props.modkey } selected={ filters } api={ getFilterReq } optionScopeFilters={ getSubordinateScopeFilters(props.filters) } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  const onDownloadSample = () => {
    makeRequestStateless(downloadSampleReq, 'companyLeaveRequests/download-sample', onSuccessDownloadSample, onSuccessDownloadSample);
  }

  const onSuccessDownloadSample = (res, err) => {
    if (res.code === undefined) {
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `company_leave_request_import.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }


  //----end filter--------------------

  return (
    <>

      { childComponent }


      <BodyComponent>

        {
          leaveTypeBalance.length > 0 &&

          <>
            <h4 >Balance</h4>
            <table className="table">
              <thead>
                <tr>
                  <th>Leave Type</th>
                  <th>Balance</th>
                  <th>Availed</th>
                  <th>Available</th>
                </tr>
              </thead>
              <tbody>
                {
                  leaveTypeBalance.map((each, key) => (
                    <tr>
                      <td>{ each.name }</td>
                      <td>{ each.acc_count }</td>
                      <td>{ each.availed }</td>
                      <td>{ each.available }</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>

          </>
        }
        { !props.employmentId && <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          { props.modkey === 'companyLeaveRequest' && <CompanyRequestFlowButton typeId="leave_request" /> }
          <DownloadButton onClick={ onDownloadSample } />
          <ImportButton onClick={ () => setChildComponent(<ImportSample onSuccess={ getAllData } api="companyLeaveRequests/import" module="Leave Requests" onCompleted={ () => setChildComponent(null) } />) } />
          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent> }
        {
          !props.employmentId && <TableComponent modkey={ props.modkey }
            loader={ loader }
            columns={ columns }
            dataSource={ dataSource }
            pagination={ { ...pagination, total: totalRecords } }
            onChange={ handleTableChange }
          />
        }
      </BodyComponent>

      { !props.employmentId && <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
      }

    </>

  );
};

export default IndexCompanyLeaveRequests;

const getFilterFields = (module) => {
  const filterFields = getRequestFilters({ hideSelfScopeFilters: module === 'myLeaveRequest' })
  filterFields.unshift(
    {
      type: "select",
      placeholder: 'Leave Type',
      key: "leave_type",
      data_key: "supporting_data.leave_type",
    },
    {
      type: "select",
      placeholder: 'Is Short',
      key: "is_short",
      data_key: "supporting_data.is_short",
    },

  )

  return filterFields;
}
